module.exports = __webpack_public_path__ + "img/SE.82f5bcab.svg";